<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="pointer-events-auto m-4 flex max-h-[720px] w-[360px] flex-col items-center justify-center rounded-lg border border-primary/10 bg-background p-4 shadow-md shadow-primary/20"
  >
    <div
      class="mb-4 flex w-full items-center justify-between"
    >
      <IconBrandLogo class="h-auto w-[12.5rem]" />

      <IconX class="opacity-20" />
    </div>
    <div
      v-if="renderedContents"
      class="prose-sm w-full overflow-y-auto pr-2 prose-a:text-primary"
      v-html="renderedContents"
    />
  </div>
</template>

<script setup lang="ts">
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeStringify from "rehype-stringify"
import rehypeSanitize from "rehype-sanitize"
import rehypeExternalLinks from "rehype-external-links"

const props = defineProps<{
  contents: string
}>()

const renderedContents = computedAsync(
  async () =>
    await unified()
      .use(remarkParse)
      .use(remarkRehype)
      .use(rehypeExternalLinks, {
        target: "_blank",
        properties: {
          className: "text-info",
        },
      })
      .use(rehypeSanitize)
      .use(rehypeStringify)
      .process(props.contents)
)
</script>
